import attachmentUrl from './attachment.svg';
import avatarIconOrangeUrl from './avatar-icon-orange.svg';
import avatarIconWhiteUrl from './avatar-icon-white.svg';
import avatarLogoHorizontalUrl from './avatar-logo-horizontal.svg';
import refreshWhiteUrl from './refresh-white.svg';
import sendWhiteUrl from './send-white.svg';

export const brandAssets = {
  attachment: attachmentUrl,
  iconOrange: avatarIconOrangeUrl,
  iconWhite: avatarIconWhiteUrl,
  /** Wordmark (icon + “avatar”) — staged for later screens */
  logoHorizontal: avatarLogoHorizontalUrl,
  refreshWhite: refreshWhiteUrl,
  sendWhite: sendWhiteUrl,
} as const;
